/* eslint-disable react-hooks/rules-of-hooks */
import * as Yup from "yup";
import { ControlState } from "../models/flexible/control-state";
import { GeneralFieldController } from "./general-field-controller";
import { useFieldValue } from "formik";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class BrandReferenceFieldController extends GeneralFieldController {
	override useControlState(path: string): ControlState {
		const index = +(path.split(".").find((e) => Number.isInteger(+e)) || 0);
		const [decisionTherapy] = useFieldValue(AttributeIdentifiers.DecisionTherapy);
		if (decisionTherapy == null) {
			return "hidden";
		}

		return this.parent.context.uniqueBrandIndexes && !this.parent.context.uniqueBrandIndexes.includes(index) ? "empty" : "disabled";
	}

	override useControlProps(_path: string) {
		return {
			controlType: "typeahead",
			property: "Name",
			optionLabel: "Name",
		};
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable().required();
	}
}
